import { render, staticRenderFns } from "./UserMealReport.vue?vue&type=template&id=4922cef6&scoped=true&"
import script from "./UserMealReport.vue?vue&type=script&lang=js&"
export * from "./UserMealReport.vue?vue&type=script&lang=js&"
import style0 from "./UserMealReport.vue?vue&type=style&index=0&id=4922cef6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4922cef6",
  null
  
)

export default component.exports